document.addEventListener("bps4:ready", function() {
    var options = { //More information on this object down in the document
        initiative_id: initiative_id,
        myProfileFields: ["location","birthday","profile.gender","data.Telephone","data.Mobilephone","data.PreferredRetailer"],
        registrationFields: ["data.Mobilephone", "birthday"],
        subscriptionFields: [],
        requiredFields: ["birthday"],
        contactUsFields: ["location", "data.Mobilephone"],
        progressiveProfiling: [
            {
                loginCounter: 3,
                title: "Sei uomo o donna?",
                subTitle: "Aiutaci a migliorare il tuo profilo completando i tuoi dati!",
                fields: ["profile.gender"],
            },
            {
                loginCounter: 4,
                title: "Quando sei nato?",
                subTitle: "Aiutaci a migliorare il tuo profilo completando i tuoi dati!",
                fields: ["birthday"],
            },
            {
                loginCounter: 5,
                title: "Dove abiti?",
                subTitle: "Aiutaci a migliorare il tuo profilo completando i tuoi dati!",
                fields: ["location"],
            },
            {
                loginCounter: 6,
                title: "Inserisci il tuo supermercato preferito",
                subTitle: "Aiutaci a migliorare il tuo profilo completando i tuoi dati!",
                fields: ["data.PreferredRetailer"],
            }
        ],
        privacyPage: "https://bps-it.bauligroup.com/privacy/?brand=bistefani",
        rulesPage: "https://bps-it.bauligroup.com/privacy/?brand=bistefani",
    };
    window.bps4.init(options);
});

document.addEventListener("bps4:loaded", function (event) {

    bps4Loaded = true;

    if (getEnv() == 'dev') { console.info("bps4:loaded", event.detail); }

    window.bps4.isUserLogged().then(function (user) {
        if (getEnv() == 'dev') { console.log(user); }
        if (user) {
            bps4__setUserInterface(user);
        }

        if(window.showScreen){
            if (window.showScreen == 'login' || window.showScreen == 'registration') {
                if(user["status"] == "FAIL"){
                    showLogin();
                }
            }
        }
    });

    if (trackAnalyticsProducts_flag) {
        setTimeout(function () {
            trackAnalyticsProducts(trackAnalyticsProducts_url, trackAnalyticsProducts_callback);
        }, 500);
    }

    if (page == 'contact') {
        showContactUs('contactUsContainer');
    }

    if (typeof callback__getAccountInfoCallback != "undefined") {
        callback__getAccountInfoCallback();
    }

    if (typeof bps4__enableCalls != "undefined") {
        bps4__enableCalls();
    }
});

document.addEventListener('bps4:onLogout', function(event) {
    if (getEnv() == 'dev') { console.log('bps4:onLogout', event.detail); }
    location.reload();
});

document.addEventListener('bps4:onLogin', function(event) {
    if (getEnv() == 'dev') { console.log('bps4:onLogin', event.detail); }
    window.bps4.isUserLogged().then(function (user) {
        if (user) {
            if (getEnv() == 'dev') { console.log(user); }
            bps4__setUserInterface(user);
        }
    });
});

document.addEventListener("bps4:onSubmitContactForm", function(event) {
    if (getEnv() == 'dev') { console.log('bps4:onSubmitContactForm', event.detail); }
    $('#modalContactSuccess').addClass('open');
    showContactUs('contactUsContainer');
})